module.exports = __webpack_public_path__ + "static/media/delete-black.81336735.svg";